import { ICategory } from 'types/GlobalCategory'
import { getWithRedirect } from 'utils/axios'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/categories`

export async function getAll() {
  return getWithRedirect<ICategory[]>(URL)
}
